import React from 'react'

import moment from 'moment'
import { connect } from 'react-redux'
import DayPickerInput from 'react-day-picker/DayPickerInput'

import Input from 'components/Input'
import Button from 'components/Button'
import RadioButton from 'components/RadioButton'
import BasePureComponent from 'utils/BasePureComponent'
import RetractablePanel from 'components/RetractablePanel'

import request from 'utils/request'
import { CLIENT_DETAIL_URL } from 'constants'
import { clientDataChanged, updateClientData } from 'scenes/ClientDetail/actions'

import './style.scss'
import 'react-day-picker/lib/style.css'

const READABLE_GENDER = {
  'F': 'Femenino',
  'M': 'Masculino'
}

export class EditAdditionalInfo extends BasePureComponent {
  constructor(props) {
    super(props)

    this.state = {
      editting: false
    }

    this.DATE_FORMAT = 'YYYY-MM-DD'
    this.today = moment().format('YYYY-MM-DD')
    this._bind('_onEdit', '_onSubmit', '_renderEditForm', '_onDateChanged', '_validatePhoneNumber')
  }

  _onDateChanged(dateObject) {
    let date = null
    try {
      date = dateObject.format(this.DATE_FORMAT)
    } catch(e) {}
    this.props.dispatch(clientDataChanged('birthdate', date))
  }

  _onEdit(evt) {
    evt.preventDefault()
    this.panel.open()
    this.setState({ editting: true })
  }

  _onSubmit(evt) {
    evt.preventDefault()
    request(CLIENT_DETAIL_URL(this.props.user.uuid), {
      method: 'PATCH',
      body: {
        phone_number: this.props.client.phone_number,
        rfc: this.props.client.rfc,
        gender: this.props.client.gender,
        birthdate: this.props.client.birthdate,
        zip_code: this.props.client.zip_code
      }
    })
    .then((client) => {
      this.setState({ editting: false })
      this.props.updateClientData(client)
    })
  }

  _renderHeaderActions() {
    return !this.state.editting ? (
      <div>
        <button onClick={this._onEdit}>
          <i className="material-icons">edit</i>
        </button>
      </div>
    ) : null
  }

  _renderData() {
    let membership = this.props.client.membership
    if (this.props.client.user_type === 'Broker') {membership = 'Broker'}
    return (
      <div className="EditAdditionalInfo__plain">
        <div>
          <strong>Teléfono:</strong>
          <span>{this.props.client.phone_number}</span>
        </div>
        <div>
          <strong>RFC:</strong>
          <span>{this.props.client.rfc}</span>
        </div>
        <div>
          <strong>Sexo:</strong>
          <span>{READABLE_GENDER[this.props.client.gender]}</span>
        </div>
        <div>
          <strong>Fecha de nacimiento:</strong>
          <span>{this.props.client.birthdate}</span>
        </div>
        <div>
          <strong>Código Postal:</strong>
          <span>{this.props.client.zip_code}</span>
        </div>
        <div>
          <strong>Tipo de usuario:</strong>
          <span>{this.props.client.user_type}</span>
        </div>
        <div>
          <strong>Membresía:</strong>
          <span>{membership}</span>
        </div>
      </div>
    )
  }

  _validatePhoneNumber(evt){
    var value = evt.target.value
    var final = ''
    var numbers = '0123456789'
    for (var i=0; i<value.length; i++){
      if (numbers.includes(value.charAt(i))) {
        final = final + value.charAt(i)
      }
    }
    this.props.dispatch(clientDataChanged(evt.target.name, final))
  }

  _renderEditForm() {
    return (
      <form onSubmit={this._onSubmit} className="EditAdditionalInfo__form">
        <Input
          name="phone_number"
          placeholder="Número telefónico"
          value={this.props.client.phone_number}
          onChange={this._validatePhoneNumber}
        />
        <Input
          name="rfc"
          placeholder="RFC"
          value={this.props.client.rfc}
          onChange={this.props.onInputChange}
        />

        <div className="EditAdditionalInfo__form__GenderRadios">
          <label>Sexo</label>
          <div className="wrapper">
            <RadioButton
              value='M'
              name="gender"
              id="gender_m"
              label="Masculino"
              onChange={this.props.onInputChange}
              checked={this.props.client.gender === 'M'}
            />
            <RadioButton
              value='F'
              name="gender"
              id="gender_s"
              label="Femenino"
              onChange={this.props.onInputChange}
              checked={this.props.client.gender === 'F'}
            />
          </div>
        </div>

        <div className="BirthdayPicker">
          <label>Fecha de nacimiento</label>
          <div className="BirthdayPicker__wrapper">
            <div className="BirthdayPicker__wrapper__icon">
              <i className="material-icons">date_range</i>
            </div>
            <DayPickerInput
              name="birthdate"
              type="text"
              format={this.DATE_FORMAT}
              onDayChange={this._onDateChanged}
              placeholder={this.DATE_FORMAT}
              value={this.props.client.birthdate || ''}
            />
          </div>
        </div>
        <Input
          placeholder="Código Postal"
          value={this.props.client.zip_code}
          onChange={this.props.onInputChange}
          name="zip_code"
        />
        <Button size="big">
          Actualizar información
        </Button>
      </form>
    )
  }

  render() {
    return (
      <div id="EditAdditionalInfo">
        <RetractablePanel
          ref={(panel) => this.panel = panel}
          name="Información adicional"
          actionButtons={this._renderHeaderActions()}
          isToggle={true}
        >
          {this.state.editting ? this._renderEditForm() : this._renderData() }
        </RetractablePanel>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.clientDetail.get('user').toJS(),
    client: state.clientDetail.get('client').toJS(),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onInputChange: (evt) => dispatch(clientDataChanged(evt.target.name, evt.target.value)),
    updateClientData: (client) => dispatch(updateClientData(client)),
    dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditAdditionalInfo)



// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/components/EditAdditionalInfo/index.js